import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Signup from './Signup';
import CreateContract from './CreateContract';
import SelectProfession from './SelectProfession';
import ViewContract from './ViewContract';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import routes from './routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <Routes>
        <Route path={routes.HOME} element={<App />} />
        <Route path={routes.SIGNUP} element={<Signup />} />
        <Route path={routes.CREATE_CONTRACT} element={<CreateContract />} />
        <Route path={routes.SELECT_PROFESSION} element={<SelectProfession />} />
        <Route path={routes.VIEW_CONTRACT} element={<ViewContract />} />
      </Routes>
    </BrowserRouter>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();